import { Component, OnInit } from '@angular/core';
import { MetadataService } from '../../metadata.service';
import { PackageBaseInfo } from '../../packagebaseinfo';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-metadatapackagelist',
  templateUrl: './metadatapackagelist.component.html',
  styleUrls: ['./metadatapackagelist.component.css']
})
export class MetadatapackagelistComponent implements OnInit {
data: PackageBaseInfo[];
packagesInfo: any;
// tslint:disable-next-line:member-ordering
public state: State = {
  skip: 0,
  take: 9999,
  // Initial filter descriptor
  filter: {
    logic: 'and',
    filters: []
  }
};
// public gridData: GridDataResult = process(this.data, this.state);
// tslint:disable-next-line:member-ordering
public gridData: GridDataResult;
public dataStateChange(state: DataStateChangeEvent): void {
  this.state = state;
  this.gridData = process(this.data, this.state);
}
// tslint:disable-next-line:member-ordering
selectableSetting: SelectableSettings = { mode: 'single', checkboxOnly: false };
  constructor(private metadataService: MetadataService) { }

  ngOnInit() {
    this.metadataService.GetMetadataPackages().subscribe(packages => {
      const tempdata = [];
      this.packagesInfo = packages;
      if (this.packagesInfo) {
        this.packagesInfo.forEach(item => {
          if (item.type === 'folder' || (item.type === 'file' && item.name.endsWith('mdpkg'))) {
            tempdata.push({'name' : item.name});
          }
        });
        this.data = tempdata;
        this.gridData = process(this.data, this.state);
      }
    });
  }

  onSelectionChange(event) {
    const packageName = event.selectedRows[0].dataItem.name;
    this.metadataService.clearPackage();
    this.metadataService.addPackage(packageName);
  }
}
